import React, { useState, useEffect, useRef } from "react";
import Input from "../element/Input/Input";

function SiteMultiSelectDropdown({
  title,
  updateFilter,
  // setFilterStatus,
}) {
  const [status, setStatus] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [filterStatus, setFilterStatus] = useState();
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (value) => {
    setCheckData(true);
    setFilterStatus(value);
  };

  const clearSelection = () => {
    setCheckData(true);
    setStatus([]);
    setFilterStatus();
  };

  useEffect(() => {
    if (checkData) {
      updateFilter("inductionType", filterStatus);
    }
  }, [filterStatus]);

  return (
    <div className="relative inline-block text-left w-32" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {status > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            {status}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X client_org_ids' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">{status} selected</span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>
          <div className="items-center max-h-48 overflow-y-auto">
            <div className="flex items-center px-3 py-2 hover:bg-gray-50">
              <label className="flex items-center space-x-2">
                <Input
                  type="radio"
                  name="status"
                  // value="active"
                  checked={filterStatus === "company"}
                  inputchangehandler={() => handleSelect("company")}
                  className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />
                <span className="text-gray-700">Company</span>
              </label>
            </div>
            <div className="flex items-center px-3 py-2 hover:bg-gray-50">
              <label className="flex items-center space-x-2">
                <Input
                  type="radio"
                  name="status"
                  checked={filterStatus === "site"}
                  inputchangehandler={() => handleSelect("site")}
                  className="w-4 h-4 text-red-600 border-gray-300 focus:ring-red-500"
                />
                <span className="text-gray-700">Site-specific</span>
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SiteMultiSelectDropdown;
